import { Button, Paper } from "@material-ui/core";
import React from 'react';
import ReactAudioPlayer from 'react-audio-player';

interface ISingleSoundProps {
    name: string;
    file: string;
}

export default class SingleSound extends React.Component<ISingleSoundProps> {
    
    state = { 
        playing: false, 
        progress: 0, 
        progressInc: 0,
        duration: 0 };

    private rap: any;

    public componentDidMount() {
        //console.log(this.rap.props);
        //this.rap.props.listenInterval = 500;
        //this.rap.props.onListen = () => this.interval();
    }

    private interval = () => {
        console.log(this.state.progressInc, this.state.progress, this.state.duration);
        this.setState({progress: this.state.progress+this.state.progressInc});
    }

    private playStart = () => {
        this.setState({
            duration: this.rap.audioEl.duration,
            progressInc: (0.05/this.rap.audioEl.duration)*100
        });
    }

    private playEnd = () => {
        this.setState({playing: false, progress: 0})
    }

    private handleClick = () => {
        if (this.state.playing) {
            this.rap.audioEl.pause();
            this.setState({playing: false});
        } else {
            this.rap.audioEl.play();
            this.setState({playing: true});
        }
    }

    public render() {
        return (
            <Paper
                elevation={4}
                style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    margin: "0.25rem",
                    background: `linear-gradient(90deg, rgba(255,0,0,1) 0%, rgba(255,0,0,1) ${this.state.progress}%, rgba(255,0,0,0.1) ${this.state.progress}%)`,
                }}
            >
                <Button
                    style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        minWidth: "10rem",
                        height: "2rem",
                    }}
                    variant="outlined"
                    onClick={this.handleClick}
                >
                    {this.props.name}
                </Button>
                <ReactAudioPlayer
                    src={this.props.file}
                    controls={false}
                    preload={"auto"}
                    listenInterval={50}
                    onListen={(element: any) => this.interval()}
                    onPlay={(element: any) => this.playStart()}
                    onEnded={(element: any) => this.playEnd()}
                    ref={(element: any) => { this.rap = element; }}
                >
                </ReactAudioPlayer>
            </Paper>
        );
    }
}
